import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Box } from "@mui/material";
import {
  setSelectedWorksheet,
  setSippsLevel,
  setSippsLesson,
  setIncludesReview,
  setIncludeComprehension,
  setIncludeImages,
  setFormData,
  selectSelectedWorksheet,
  selectSippsLesson,
  selectSippsLevel,
  selectIncludeComprehension,
  selectIncludeImages,
  selectIncludesReview,
  selectFormData,
} from "../../../../slices/form";
import styles from "./questionTypes.module.css"; 
import util from "../../../../styles/utilities.module.css";
import SippsLevelLessonSelector from "./SippsLevelLessonSelector"; 
import {MATCHING_TYPES} from '../../../../constants';


const SippsQuestions = () => {
  const dispatch = useDispatch();

  const selectedWorksheet = useSelector(selectSelectedWorksheet);
  const sippsLevel = useSelector(selectSippsLevel);
  const sippsLesson = useSelector(selectSippsLesson);
  const includesReview = useSelector(selectIncludesReview);
  const includeComprehension = useSelector(selectIncludeComprehension);
  const includeImages = useSelector(selectIncludeImages);
  const formData = useSelector(selectFormData);

  useEffect(() => {
    if (sippsLevel == null){
      dispatch(setSippsLevel('beginning'));
      dispatch(setSippsLesson(4));
    }
    if (includesReview == null) {
      dispatch(setIncludesReview(false));
    }
  }, [sippsLevel,includesReview, dispatch]);

  const handleButtonClick = (num) => {
    dispatch(setSelectedWorksheet(selectedWorksheet === num ? null : num));
  };

  const getFilteredWorksheets = () => {
    if (sippsLevel === 'beginning' && sippsLesson < 4) {
      return [];
    } else if (sippsLevel==='beginning' && sippsLesson >= 4 && sippsLesson < 11) {
      return [1, 5];
    } else if (sippsLevel==='beginning' && sippsLesson >= 11 && sippsLesson < 26) {
      // Remove reading practice under 26, generally poor results
      return [1,2,3,4,5,6,8];
    } else if (sippsLevel && sippsLevel.startsWith('challenge')) {
      return [ 7, 8 ];
    } else if (sippsLevel === 'beginning') {
      return [1, 2, 3, 4, 5, 6, 7, 8];
    } else {
      // Extension level (not beginning or challenge)
      // Remove tongan for now - not sure if translations are good
      return [1, 2, 3, 4, 7, 8];
    }
  };

  const filteredWorksheets = getFilteredWorksheets();


  const handleIncludesReviewChange = (event) => {
    dispatch(setIncludesReview(event.target.checked));
  };

  const handleIncludeComprehensionChange = (event) => {
    dispatch(setIncludeComprehension(event.target.checked));
  };

  const handleIncludeImagesChange = (event) => {
    const checked = event.target.checked;
    dispatch(setIncludeImages(checked));
    // Clear any previous image_speed setting when image selection changes
    dispatch(setFormData({ image_speed: "fast" }));
  }

  const handleImageSpeedChange = (event) => {
    const checked = event.target.checked;
    // When checked, send "slow" as image_speed, otherwise send "fast"
    dispatch(setFormData({ image_speed: checked ? "slow" : "fast" }));
  };


  return (
    <Box sx={{ display: "flex", flexDirection: "column", alignItems: "flex-start", marginTop: 4 }}>
      <SippsLevelLessonSelector sippsLevel={sippsLevel} sippsLesson={sippsLesson} />
      <div className={styles.mainSection}>      
        <div className={styles.individualCheckbox} style={{ marginBottom: "20px" }}>
          <label className={styles.container}>
            <input
              type="checkbox"
              checked={selectedWorksheet === 7 ? true : includesReview}
              disabled={selectedWorksheet === 7}
              onChange={handleIncludesReviewChange}
            />
            <span className={styles.checkmark}></span>
          </label>
          <span style={{ color: selectedWorksheet === 7 ? "grey" : "inherit" }}>
            Include Review
            {selectedWorksheet === 7 && " (expanded word set including review required for reading practice)"}
          </span>
        </div>
      </div>
      <div className={styles.mainSection}>
        <p className={styles.label}>Select a Worksheet</p>
      </div>
      <div style={{ display: "flex", flexWrap: "wrap" }}>
        {Object.entries(MATCHING_TYPES)
          .filter(([num]) => filteredWorksheets.includes(Number(num)))
          .map(([num, label]) => (
            <button
              key={num}
              type="button"
              className={`${util.btn} ${selectedWorksheet === Number(num) ? `${util['btn--primary']} ${styles.buttonSelected}` : util['btn--ghost']}`}
              onClick={() => handleButtonClick(Number(num))}
            >
              {label}
            </button>
          ))}
      </div>
      {selectedWorksheet === 7 && (
        <>
        <br />
        <div className={styles.individualCheckbox} >
          <label className={styles.container}>
            <input
              type="checkbox"
              checked={includeComprehension}
              onChange={handleIncludeComprehensionChange}
            />
            <span className={styles.checkmark}></span>
          </label>
          <span>Include reading comprehension questions</span>
        </div>
        <div className={styles.individualCheckbox} >
          <label className={styles.container}>
            <input
              type="checkbox"
              checked={includeImages}
              onChange={handleIncludeImagesChange}
            />
            <span className={styles.checkmark}></span>
          </label>
          <span>Include an image with the text</span>
        </div>
        {includeImages && (
          <div className={styles.individualCheckbox} style={{ marginLeft: 24 }}>
            <label className={styles.container}>
              <input
                type="checkbox"
                checked={formData?.image_speed === "slow"}
                onChange={handleImageSpeedChange}
              />
              <span className={styles.checkmark}></span>
            </label>
            <span>Slower, higher quality image generation</span>
          </div>
        )}
      </>
      )}
      <div className={styles.mainSection}>

      </div> 
    </Box>
  );
};

export default SippsQuestions;
